import React, { lazy } from 'react';
import GraciasV2 from './views/pages/2023/GraciasV2';
//PAGES

const Home = lazy(import('./views/pages/Home'))
const CotizadorVolumetrico = React.lazy(() => import('./views/pages/CotizadorVolumetrico'))
const Cotizar = React.lazy(() => import('./views/pages/Cotizar'))
const CotizarC = React.lazy(() => import('./views/pages/CotizarC'))
const Login = React.lazy(() => import('./views/pages/Login'))
const Registrate = React.lazy(() => import('./views/pages/Registrate'))
const Terms = React.lazy(() => import('./views/pages/Terms'))
const AvisoPrivacidad = React.lazy(() => import('./views/pages/AvisoPrivacidad'))
const Hashogin = React.lazy(() => import('./views/pages/Hashogin'))
const Contacto = React.lazy(() => import('./views/pages/Contacto'))
const Cotizacion2021 = React.lazy(() => import('./views/pages/Cotizacion2021'))
const CotizacionB = React.lazy(() => import('./views/pages/CotizacionB'))
const CotizacionLibre = React.lazy(() => import('./views/pages/Cotizacion2021Libre'))
const TuCotizacion = React.lazy(() => import('./views/pages/2023/TuCotizacion'))
const EntregaBodegaConfirmada = React.lazy(() => import('./views/pages/2024/EntregaEnBodegaConfirmada'))

const Cookies = React.lazy(() => import('./views/pages/Cookies'))
const ReceiptPaid = React.lazy(() => import('./views/pages/ReceiptPaid'))
const CotizaAsesor = React.lazy(() => import('./views/pages/CotizaAsesor'))
const RedirectPage = React.lazy(() => import('./views/pages/RedirectPage'))
const RequestPasswordRecover = React.lazy(() => import('./views/pages/RequestPasswordRecover'))
const SolicitudPagoV3 = React.lazy(() => import('./views/pages/2023/SolicitudPagoV3'))
const SolicitudPago = React.lazy(() => import('./views/pages/SolicitudPago'))
const SolicitudPagoV2 = React.lazy(() => import('./views/pages/SolicitudPagoV2'))
const Authologin = React.lazy(() => import('./views/pages/Authologin'))
const PasswordRecover = React.lazy(() => import('./views/pages/PasswordRecover'))
const NuevaPagina = React.lazy(() => import('./views/pages/NuevaPagina'))
const NuevaPaginaGif = React.lazy(() => import('./views/pages/NuevaPaginaGif'))
const GraciasFormularios = React.lazy(() => import('./views/pages/Gracias'))
const GraciasMubitExpress = React.lazy(() => import('./views/pages/GraciasMubitExpress'))
const LandingEmpresas = React.lazy(() => import('./views/pages/LandingEmpresas'))
const InventarioListoV2 = React.lazy(() => import('./views/pages/2023/InventarioListoV2'))


//HELIUM LANDINGS
const LandingWixOne = React.lazy(() => import('./views/pages/2022/LandingWixOne'))
//MI CUENTA
const Perfil = React.lazy(() => import('./views/pages/mi-cuenta/Perfil'))
const Inventarios = React.lazy(() => import('./views/pages/mi-cuenta/Inventarios'))
const InventariosSI = React.lazy(() => import('./views/pages/mi-cuenta/InventariosSI'))
const ConfirmarCita = React.lazy(() => import('./views/pages/mi-cuenta/ConfirmarCita'))
const ConfirmarCitaV2 = React.lazy(() => import('./views/pages/mi-cuenta/ConfirmarCitaV2'))
const Gracias = React.lazy(() => import('./views/pages/mi-cuenta/Gracias'))
const ConfirmarEntrega = React.lazy(() => import('./views/pages/mi-cuenta/ConfirmarEntrega'))
const Adeudo = React.lazy(() => import('./views/pages/mi-cuenta/Adeudo'))
const Pagos = React.lazy(() => import('./views/pages/mi-cuenta/Pagos'))
const Recibo = React.lazy(() => import('./views/pages/mi-cuenta/Recibo'))
const Facturacion = React.lazy(() => import('./views/pages/mi-cuenta/Facturacion'))
const Entrega = React.lazy(() => import('./views/pages/mi-cuenta/Entrega'))
const UnMesMas = React.lazy(() => import('./views/pages/mi-cuenta/UnMesMas'))


const Routes = {
    CotizadorVolumetrico: {
        url: '/',
        component: CotizadorVolumetrico
    },
    nuevaLanding: {
        url: '/',
        component: NuevaPagina
    },
    nuevaLandingGif: {
        url: '/',
        component: NuevaPaginaGif
    },
    LandingWixOne: {
        url: '/bodegas',
        component: LandingWixOne
    },
    Login: {
        url: '/iniciar-sesion',
        component: Login
    },
    Registrate: {
        url: '/registro',
        component: CotizadorVolumetrico
    },
    NewRequest: {
        url: '/comenzar',
        component: CotizarC
    },
    SolicitudPago: {
        url: '/pv1/',
        component: SolicitudPago
    },
    SolicitudPagoV2: {
        url: '/pv2/',
        component: SolicitudPagoV2
    },
    SolicitudPagoV3: {
        url: '/p/',
        component: SolicitudPagoV3
    },
    Authologin: {
        url: '/auth/',
        component: Authologin
    },
    NewRequest2: {
        url: '/cotizar',
        component: NuevaPagina
    },
    Terms: {
        url: '/terminos-y-condiciones',
        component: Terms
    },
    AvisoPrivacidad: {
        url: '/aviso-de-privacidad',
        component: AvisoPrivacidad
    },
    Contacto: {
        url: '/contacto',
        component: Contacto
    },
    ReceiptPaid: {
        url: '/confirmacion-pago/',
        component: ReceiptPaid
    },
    Cotizacion: {
        url: '/cotizacion/',
        component: Cotizacion2021
    },
    CotizacionB: {
        url: '/mi-cotizacion/',
        component: CotizacionB
    },
    InventarioListo: {
        url: '/inventario-listo',
        component: InventarioListoV2
    },
    CotizacionLibre: {
        url: '/tu-cotizacion-v1/',
        component: CotizacionLibre
    },
    CotizacionV2: {
        url: '/tu-cotizacion/',
        component: TuCotizacion
    },
    EntregaBodega: {
        url: '/entrega-en-bodega-confirmada/',
        component: EntregaBodegaConfirmada
    },
    Perfil: {
        url: '/mi-cuenta/perfil',
        component: Perfil
    },
    Inventarios: {
        url: '/mi-cuenta/inventario',
        component: Inventarios
    },
    InventariosSI: {
        url: '/mi-cuenta/inventario-si',
        component: InventariosSI
    },
    QuedarmeUnMesMas: {
        url: '/mi-cuenta/quedarme-un-mes-mas',
        component: UnMesMas
    },
    Adeudo: {
        url: '/mi-cuenta/adeudo',
        component: Adeudo
    },
    Pagos: {
        url: '/mi-cuenta/pagos',
        component: Pagos
    },
    Recibo: {
        url: '/mi-cuenta/recibo',
        component: Recibo
    },
    ConfirmarCita: {
        url: '/mi-cuenta/confirmar-cita-old',
        component: ConfirmarCita
    },
    ConfirmarCitaV2: {
        url: '/mi-cuenta/confirmar-cita',
        component: ConfirmarCitaV2
    },
    Gracias: {
        url: '/mi-cuenta/cita-confirmada/gracias',
        component: Gracias
    },
    ConfirmarEntrega: {
        url: '/mi-cuenta/confirmar-entrega',
        component: ConfirmarEntrega
    },
    Facturacion: {
        url: '/mi-cuenta/facturacion',
        component: Facturacion
    },
    Entregas: {
        url: '/mi-cuenta/entregas',
        component: Entrega
    },
    Hashogin: {
        url: '/hashogin',
        component: Hashogin
    },
    PasswordRecover: {
        url: '/nueva-contrasena',
        component: PasswordRecover
    },
    RequestPasswordRecover: {
        url: '/recuperacion-contrasena',
        component: RequestPasswordRecover
    },
    CotizaAsesor: {
        url: '/cotiza-con-asesor',
        component: CotizaAsesor
    },
    Cookies: {
        url: '/politica-cookies',
        component: Cookies
    },
    GraciasFormularios: {
        url: '/gracias',
        component: GraciasV2
    },
    GraciasMubitExpress: {
        url: '/gracias-express',
        component: GraciasV2
    },
    GraciasMubitFinal: {
        url: '/gracias-final',
        component: GraciasV2
    },
    GraciasMubitNosotros: {
        url: '/gracias-nosotros',
        component: GraciasV2
    },
    GraciasMubitInicio: {
        url: '/gracias-inicio',
        component: GraciasV2
    },
    Redirect: {
        url: '',
        component: RedirectPage
    }

}

export default Routes;